import * as React from 'react';
import GeneralInformation from './generalInformation';
import AuthProvider from './authProvider';
import LoginHistory from './loginHistory';
import EmailChangeHistory from './emailChangeHistory';
import MemberComment from './memberComment';

interface Props {
  userId: string;
}

const MemberDetailGeneral = ({ userId }: Props) => {
  return (
    <>
      <GeneralInformation />
      <AuthProvider />
      <LoginHistory userId={userId} />
      <EmailChangeHistory />
      <MemberComment userId={userId} />
    </>
  );
};

export default MemberDetailGeneral;
